exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".radius-10[data-v-1b608816]{border-radius:10px}.content .border-b[data-v-1b608816]{border-bottom:1px solid #eef1f6}.content .border-b-2[data-v-1b608816]{border-bottom:2px solid #eef1f6}.content .skillListTitle[data-v-1b608816]{height:36px;background:#eef1f6;border-top-left-radius:9px;border-top-right-radius:9px}.content .skillListTitle h2[data-v-1b608816]{display:block;float:left;margin-top:7px!important}.content .skillListTitle button[data-v-1b608816]{float:right;margin-left:5px}.content .line-right button[data-v-1b608816]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;width:100%}.content .line-right i[data-v-1b608816]:hover{color:#20a0ff}@-moz-document url-prefix(){.line-right button{text-align:left}}.question-title[data-v-1b608816]{display:table}.owner[data-v-1b608816]{position:absolute;top:-68px;right:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-1b608816","scoped":true,"hasInlineConfig":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/student/Report.vue
// module id = 528
// module chunks = 1